<template>
  <div id="app-main">
    <el-row>
      <el-col>
        <div class="page-title-box flex-between">
          <h4 class="page-title">
            无效课程
            <span class="sub-title">无活动课程、无学生课程、无教师课程</span>
          </h4>

          <div class="page-title date-range">
            统计范围：{{ courseTime }}
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content">无效课程不纳入课程数的统计</div>
              <i class="mdi mdi-help-circle-outline"></i>
            </el-tooltip>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="mb-3">
      <el-col class="select-auto-fit-style">
        <el-select
          class="schoolyear range-condition"
          v-model="schoolyear"
          @change="handleSchoolyear"
          placeholder="请选择学期"
          filterable
        >
          <template slot="prefix">
            {{ (schoolyearOption.find(v => v.id === schoolyear) || {}).name }}
          </template>
          <el-option
            v-for="item in schoolyearOption"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          class="institute range-condition"
          v-model="institute"
          @change="handleInstitute"
          placeholder="请选择学院"
          filterable
        >
          <template slot="prefix">
            {{ (instituteOption.find(v => v.id === institute) || {}).name }}
          </template>
          <el-option
            v-for="item in instituteOption"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :class="!item.disabled && item.env === 'sysu' ? 'level2-option' : ''"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-card>
          <el-row class="mb-3 flex-between">
            <el-col>
              <div class="flex-between">
                <div>
                  <el-button type="primary" @click="exportTable">导出表格</el-button>
                </div>
                <div>
                  <el-select
                    class="judge-condition range-condition"
                    v-model="judgeCondition"
                    @change="handleJudgeCondition"
                  >
                    <el-option value="0" label="请选择判断依据"></el-option>
                    <el-option
                      v-for="item in judgeConditionOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="mb-3">
            <el-col>
              <el-table id="invalid-course-table" :data="courseData" stripe>
                <el-table-column prop="course_id" label="课程ID" width="80"></el-table-column>
                <el-table-column prop="category" label="课程类别" width="180"></el-table-column>
                <el-table-column prop="fullname" label="课程全称">
                  <template slot-scope="scope">
                    <el-link class="operative" @click="checkCourse(scope.row)">
                      {{ scope.row.fullname }}
                    </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="shortname" label="课程简称"></el-table-column>
                <el-table-column prop="start_time" label="开始时间" width="120"></el-table-column>
                <el-table-column prop="end_time" label="结束时间" width="120"></el-table-column>
                <el-table-column prop="teachers" label="任课教师"></el-table-column>
                <el-table-column prop="judgment" label="判断依据" width="180"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <a href=""></a>
          <div class="row flex-end">
            <Pagination
              :totalSize="totalSize"
              :currentPage="currentPage"
              @setPageSizesVal="getPageSizesVal"
              @setCurPageVal="getCurPageVal"
            ></Pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import { getCascader } from '@/utils/format.js'
import { domainName } from '@/config/setting.js'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      schoolyear: '0',
      schoolyearOption: [],
      institute: '0',
      instituteOption: [],
      judgeCondition: '0',
      judgeConditionOption: [
        { id: 1, name: '无活动课程' },
        { id: 2, name: '无学生课程' },
        { id: 3, name: '无教师课程' },
      ],
      courseData: [],
      courseTime: '',
      // 页码数据
      totalSize: null,
      currentPage: 1,
      pageSizesVal: 10,
    }
  },
  mounted() {
    Promise.all([this.getSemesterApi(), this.getCollegeApi()])
      .then(() => {
        this.getInvalidCourseApi()
      })
      .catch(err => {
        this.$message.warning(err)
      })
  },
  methods: {
    // 获取无效课程列表/下载表格
    async getInvalidCourseApi(type = '') {
      await this.$store
        .dispatch('platform/getInvalidCourse', {
          semester_id: +this.schoolyear,
          category_id: +this.institute,
          type: +this.judgeCondition,
          page: this.currentPage,
          pagesize: this.pageSizesVal,
          print: type === 'download' ? 1 : 0,
          responseType: type === 'download' ? 'blob' : '',
        })
        .then(res => {
          if (type === 'download') {
            const link = document.createElement('a') // 创建a标签
            let blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            }) //文件流处理
            link.style.display = 'none' //去除a标签的样式
            // 设置连接
            link.href = URL.createObjectURL(blob)
            link.download = '无效课程'
            document.body.appendChild(link)
            //模拟点击事件
            link.click()
            //移除创建的a标签
            window.URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          } else if (res.code === 1) {
            console.log('res:', res)
            this.courseTime = res.data.time
            this.courseData = res.data.data.list
            this.totalSize = res.data.data.paging.records
            console.log('courseStatsData', this.courseData)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取学期数据接口
    async getSemesterApi() {
      await this.$store
        .dispatch('commom/getSemester')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.schoolyearOption = res.data
            if (this.schoolyearOption.length > 0) {
              this.schoolyear = this.schoolyearOption[0].id
            }
            this.schoolyearOption = [
              {
                id: '0',
                name: '全部学期',
              },
            ].concat(this.schoolyearOption)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取学院数据接口
    async getCollegeApi() {
      await this.$store
        .dispatch('commom/getCollege')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.instituteOption = []
            console.log('appmode')
            let treeData = getCascader(res.data)
            switch (process.env.VUE_APP_MODE) {
              case 'sysu':
                for (let firstLevelItem of treeData) {
                  firstLevelItem.env = 'sysu'
                  this.instituteOption.push(firstLevelItem)
                  let childNodes = firstLevelItem.children
                  // 对每一个子节点都进行深度优先遍历
                  if (childNodes.length) {
                    childNodes.forEach(item => {
                      item.env = 'sysu'
                      this.instituteOption.push(item)
                    })
                  }
                }
                break
              default:
                for (let firstLevelItem of treeData) {
                  firstLevelItem.env = 'others'
                  firstLevelItem.disabled = false
                  this.instituteOption.push(firstLevelItem)
                }
                break
            }
            this.instituteOption = [
              {
                id: '0',
                name: '全部学院',
              },
            ].concat(this.instituteOption)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 查看课程跳转
    checkCourse(row) {
      console.log('row', row)
      window.open(domainName + '/course/view.php?id=' + row.course_id, '_blank')
    },
    // 筛选处理
    handleSchoolyear() {
      this.getInvalidCourseApi()
    },
    handleInstitute() {
      this.getInvalidCourseApi()
    },
    handleJudgeCondition() {
      this.getInvalidCourseApi()
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getInvalidCourseApi()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getInvalidCourseApi()
    },
    exportTable() {
      this.getInvalidCourseApi('download')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .schoolyear.el-select .el-input__inner {
    width: 180px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .institute.el-select .el-input__inner {
    width: 240px;
    padding-left: 0;
    border: none;
    background: none;
    font-size: 20px;
    font-weight: bold;
    color: #3294f6;
  }
  .schoolyear.el-select .el-input .el-select__caret,
  .institute.el-select .el-input .el-select__caret {
    color: #3294f6;
    font-weight: bold;
  }
  .schoolyear.el-select,
  .institute.el-select {
    .el-input__inner::placeholder {
      color: #3294f6;
    }
  }
  .el-input {
    .el-input__inner {
      border-radius: 3px;
    }
  }
  .select-auto-fit-style {
    .el-input__prefix {
      // prefix与input的样式保持一致，这样才能与原来重合对齐
      font-size: 20px;
      font-weight: bold;
      line-height: 40px;
      padding-right: 30px;
      left: 0;
      position: relative;
      visibility: hidden;
      text-align: center;
    }
    .el-input__inner {
      position: absolute;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
.page-title-box {
  h4.page-title {
    font-weight: 600;
    .sub-title {
      font-size: 14px;
      color: #98a6ad;
      line-height: 21px;
      font-weight: 500;
    }
  }
}
.date-range {
  color: rgba(108, 117, 125, 1);
  font-size: 14px;
}
.range-condition {
  margin-right: 24px;
}
.selectbox {
  margin-right: 11px;
}
.empty-course {
  height: 320px;
  background-color: white;
  background-repeat: no-repeat;
  background-clip: content-box;
  .empty-course-tips {
    margin-top: 24px;
    color: rgba(152, 166, 173, 1);
    font-size: 18px;
  }
}
.course-card {
  cursor: pointer;
  .cover-img {
    width: 100%;
    height: 0;
    padding-bottom: 55.4%;
    overflow: hidden;
    background-image: url('~@/assets/images/course/course-cover.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
  .course-name {
    margin-top: 24px;
    color: rgba(52, 58, 64, 1);
    font-size: 18px;
    line-height: 18px;
    font-weight: bold;
  }
  .teacher-name {
    margin-top: 16px;
    color: rgba(152, 166, 173, 1);
    font-size: 14px;
    line-height: 14px;
  }
}
.level2-option {
  padding-left: 30px;
}
.operative {
  color: #409eff;
  margin-right: 1rem;
  cursor: pointer;
}
</style>
